export default __webpack_public_path__ + "static/media/Assinatura.e939c0c9.png";